import React, { useEffect, useCallback, useState } from "react";
import ReactPlayer from "react-player";
import styles from "./VideoPlayer.module.css";
const VideoPlayer = ({ open, url, onClose, autoPlay = true }) => {
  const close = useCallback(() => onClose?.(), [onClose]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => e.key === "Escape" && close();
    window.addEventListener("keydown", onKeyDown);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prev;
    };
  }, [open, close]);

  if (!open) return null;

  return (
    <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
      <button className={styles.closeBtn} onClick={close} aria-label="بستن">
        ✕
      </button>
      <div className={styles.playerWrap}>
        <ReactPlayer
          url={url}
          controls
          playing={autoPlay}
          width="100%"
          height="100%"
          playsinline
          config={{ file: { attributes: { controlsList: "nodownload" } } }}
        />
      </div>
    </div>
  );
};
export default VideoPlayer;
